(() => {
  function init() {
    document.querySelectorAll('[data-sk-player]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-sk-team-filter-form]');
      form?.querySelector('[data-sk-team-sort]')?.addEventListener('change', () => {
        if (matchMedia('(max-width:749px)').matches) form.requestSubmit();
      });
      root.querySelector('[data-sk-team-bag]')?.addEventListener('click', event => {
        if (!matchMedia('(max-width:749px)').matches) return;
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (typeof drawer?.open === 'function') { event.preventDefault(); drawer.open(); }
      });
      const products = [...root.querySelectorAll('[data-sk-player-product]')];
      const more = root.querySelector('[data-sk-player-more]');
      const result = root.querySelector('[data-sk-player-result]');
      const updateResult = () => {
        const shown = products.filter(product => !product.hidden).length;
        if (result) result.textContent = `Showing ${shown} of ${products.length} jerseys`;
        if (more) more.hidden = shown >= products.length;
      };
      more?.addEventListener('click', () => {
        products.filter(product => product.hidden).slice(0, 8).forEach(product => { product.hidden = false; });
        updateResult();
      });
      updateResult();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', init);
})();
